<template>
	<view class="share">
		<view class="head" :style="{ height: 'calc(' + (navHeight + statusbarHeight + 'px)') }">
			<view class="head-bar" :style="{ height: navHeight + statusbarHeight + 'px' }">
				<view :style="{ width: '100%', height: statusbarHeight + 'px' }"></view>
				<view class="head-bar-nav" :style="{ height: navHeight + 'px' }">
					<image src="/static/icon/nav_ic_back@2x.png" mode="widthFix"></image>
					<text>分享</text>
				</view>
			</view>
		</view>
		<view class="image" :style="{ backgroundImage: 'url(' + backgroundImge + ')', top: -navHeight + 'px' }"></view>
		<view class="list">
			<view class="list-item">
				<view class="list-item-list">
					<view class="list-item-list-item">
						<image src="/static/icon/yaoqing_ic_a@2x.png" mode="widthFix"></image>
						<text>邀请好友</text>
					</view>
					<image class="list-item-list-next" src="/static/icon/yaoqing_ic_ar@2x.png" mode="widthFix"></image>
					<view class="list-item-list-item">
						<image src="/static/icon/yaoqing_ic_b@2x.png" mode="widthFix"></image>
						<text>好友首次登录获积分</text>
					</view>
					<image class="list-item-list-next" src="/static/icon/yaoqing_ic_ar@2x.png" mode="widthFix"></image>
					<view class="list-item-list-item">
						<image src="/static/icon/yaoqing_ic_c@2x.png" mode="widthFix"></image>
						<text>完成首单获优惠券</text>
					</view>
				</view>
				<view class="list-item-btn">立即邀请</view>
				<view class="list-item-tips">成功邀请好友可享任务好礼</view>
			</view>
			<view class="list-item" style="margin-bottom: 40rpx;">
				<view class="list-item-cate">
					<view class="list-item-cate-item">
						<text>已成功邀请(人)</text>
						<text>5</text>
					</view>
					<view class="list-item-cate-item">
						<text>积分奖励</text>
						<text>1000</text>
					</view>
					<view class="list-item-cate-item">
						<text>优惠券奖励</text>
						<text>查看</text>
					</view>
				</view>
			</view>
			<view class="list-item" style="padding-top: 50rpx; box-sizing: border-box;">
				<view class="list-item-top">
					<image src="/static/images/yaoqing_title@2x.png" mode="widthFix"></image>
				</view>
				<view class="list-item-row" v-for="(item, index) in 10" :key="index">
					<view class="user">
						<view class="user-image">
							<image src="/static/logo.png" mode="widthFix"></image>
						</view>
						<view class="user-info">
							<text>黄轩平</text>
							<text>2025-11-21 19:12:32</text>
						</view>
					</view>
					<view class="statis">完成首单</view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		computed: {
			...mapState(['navHeight', 'statusbarHeight'])
		},
		data() {
			return {
				backgroundImge: require('@/static/images/fenxiang_ic@2x.png')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.share {
		width: 100%;
		background: linear-gradient( 180deg, #FE6D27 0%, #B11F00 100%);
		.head {
			width: 100%;
			height: 424rpx;
			padding: 0 30rpx;
			position: sticky;
			top: 0;
			left: 0;
			z-index: 999;
			box-sizing: border-box;
			position: sticky;
			top: 0;
			left: 0;
			z-index: 999;
			.head-bar {
				width: 100%;
		
				.head-bar-nav {
					width: 100%;
					display: flex;
					align-items: center;
					image {
						width: 44rpx;
						height: 44rpx;
					}
					text {
						font-weight: 500;
						font-size: 32rpx;
						color: #FFFFFF;
					}
				}
			}
		}
		.image {
			width: 100%;
			height: 674rpx;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			position: relative;
			left: 0;
		}
		.list {
			width: 100%;
			padding: 0 30rpx;
			box-sizing: border-box;
			position: relative;
			top: -210rpx;
			left: 0;
			.list-item {
				width: 100%;
				padding: 30rpx 0;
				box-sizing: border-box;
				background: #FFFFFF;
				border-radius: 20rpx;
				margin-bottom: 20rpx;
				position: relative;
				&:last-child {
					margin: 0 !important;
				}
				.list-item-top {
					width: 354rpx;
					height: 72rpx;
					position: absolute;
					top: -24rpx;
					left: 50%;
					z-index: 999;
					transform: translate(-50%, 0);
					image {
						width: 100%;
						height: 100%;
					}
				}
				.list-item-row {
					width: 100%;
					padding: 30rpx 32rpx;
					box-sizing: border-box;
					border-bottom: 1rpx solid #E5E5E5;
					display: flex;
					align-items: center;
					.user {
						flex: 1;
						display: flex;
						align-items: center;
						.user-image {
							width: 80rpx;
							height: 80rpx;
							border-radius: 50%;
							overflow: hidden;
							margin-right: 16rpx;
							image {
								width: 100%;
							}
						}
						.user-info {
							height: 80rpx;
							display: flex;
							flex-direction: column;
							justify-content: space-between;
							text {
								&:nth-child(1) {
									font-weight: 600;
									font-size: 30rpx;
									color: #333333;
								}
								&:nth-child(2) {
									font-weight: 400;
									font-size: 24rpx;
									color: #999999;
								}
							}
						}
					}
					.statis {
						font-weight: 400;
						font-size: 26rpx;
						color: #E4001D;
					}
				}
				.list-item-cate {
					width: 100%;
					display: flex;
					align-items: center;
					.list-item-cate-item {
						flex: 1;
						height: 98rpx;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						justify-content: space-between;
						border-right: 1rpx solid #EEEEEE;
						&:last-child {
							border: none;
						}
						text {
							&:nth-child(1) {
								font-weight: 400;
								font-size: 24rpx;
								color: #333333;
							}
							&:nth-child(2) {
								font-weight: 600;
								font-size: 34rpx;
								color: #E4001D;
							}
						}
					}
				}
				.list-item-list {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.list-item-list-item {
						flex: 1;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
						image {
							width: 88rpx;
							height: 88rpx;
						}
						text {
							font-weight: 400;
							font-size: 24rpx;
							color: #333333;
							margin-top: 10rpx;
						}
					}
					.list-item-list-next {
						flex-shrink: 0;
						width: 14rpx;
						height: 16rpx;
					}
				}
				.list-item-btn {
					width: 594rpx;
					height: 80rpx;
					line-height: 80rpx;
					text-align: center;
					background: linear-gradient( 90deg, #FF2E0F 0%, #FF6241 100%);
					box-shadow: 0rpx 4rpx 16rpx 0rpx rgba(255,63,35,0.36);
					border-radius: 44rpx;
					font-weight: 600;
					font-size: 32rpx;
					color: #FFFFFF;
					margin: 0 auto;
					margin-top: 36rpx;
				}
				.list-item-tips {
					width: 100%;
					text-align: center;
					margin-top: 32rpx;
					font-weight: 400;
					font-size: 24rpx;
					color: #666666;
				}
			}
		}
	}
</style>